<template>
    <input 
        type="radio" 
        :id="id"
        :name="name"
        :value="value"
        :checked="isChecked"
        @change="handleChange"
        class="radio__input"
    />
</template>

<script>
export default {
    name: 'TRadio',
    
    props: {
        id: {
            type: String,
            default: null
        },
        name: {
            type: String,
            required: true
        },
        value: {
            type: [String, Number, Boolean],
            default: null
        },
        modelValue: {
            type: [String, Number, Boolean],
            default: null
        }
    },
    
    emits: ['update:modelValue', 'change'],
    
    computed: {
        isChecked() {
            return this.modelValue === this.value;
        }
    },
    
    methods: {
        handleChange(event) {
            this.$emit('update:modelValue', this.value);
            this.$emit('change', event);
        }
    }
}
</script>
